<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetPrice" });
import { Heading } from "../../../../../typography/index.js";
import { InputRadio } from "../../../../../selects/index.js";
import { InputMonetary, InputPercentage } from "../../../../../inputs/index.js";
import { onDestroy, onMount } from "svelte";
export let subscription;
let option = void 0;
let itemPrice = void 0;
let kiloPrice = void 0;
const DOMAIN = import.meta.env.VITE_DOMAIN;
const clearDiscount = () => {
    if (subscription.constraints?.minimum === void 0) {
        return;
    }
    subscription.constraints.minimum.discount = void 0;
};
const initialize = () => {
    if (subscription.constraints?.maximumUnitPrice !== void 0 && subscription.constraints.priceUnit === "unit") {
        option = "perItem";
        clearDiscount();
        itemPrice = subscription.constraints.maximumUnitPrice;
        kiloPrice = void 0;
        return;
    }
    if (subscription.constraints?.maximumUnitPrice !== void 0 && subscription.constraints.priceUnit === "kg") {
        option = "perKg";
        clearDiscount();
        kiloPrice = subscription.constraints.maximumUnitPrice;
        itemPrice = void 0;
        return;
    }
    option = "discount";
};
onMount(() => {
    initialize();
});
const clearPrices = () => {
    if (subscription.constraints === void 0) {
        return;
    }
    subscription.constraints.maximumUnitPrice = void 0;
    subscription.constraints.priceUnit = void 0;
    itemPrice = void 0;
    kiloPrice = void 0;
};
const onOptionChange = (option2) => {
    if (option2 === void 0) {
        return;
    }
    if (option2 === "discount") {
        clearPrices();
        return;
    }
    clearDiscount();
    if (option2 === "perItem") {
        kiloPrice = void 0;
    }
    else {
        itemPrice = void 0;
    }
};
$: onOptionChange(option);
onDestroy(() => {
    if (subscription.constraints === void 0) {
        return;
    }
    if (itemPrice !== void 0) {
        subscription.constraints.maximumUnitPrice = itemPrice;
        subscription.constraints.priceUnit = "unit";
    }
    if (kiloPrice !== void 0) {
        subscription.constraints.maximumUnitPrice = kiloPrice;
        subscription.constraints.priceUnit = "kg";
    }
});
</script>

{#if subscription.constraints !== undefined}
    <div class = 's8-step-container'>
        <Heading size = 'xs'>
            { DOMAIN === 'internal'
                ? 'Which price specification is most relevant to them?'
                : 'Which price do you have in mind?' }
        </Heading>

        <div class = 's8-options'>
            <div>
                <InputRadio
                    bind:key = { option }
                    name = 'price-selection'
                    value = 'discount'
                    label = 'Minimum RRP Discount'
                />
                {#if subscription.constraints.minimum !== undefined}
                    <InputPercentage
                        bind:value = { subscription.constraints.minimum.discount }
                        name = 'subscription.discount'
                        maximum = { 99.99 }
                        placeholder = { DOMAIN === 'internal' ? 'E.g. 72' : 'E.g. 72% off RRP for running shoes' }
                        isDisabled = { option !== 'discount' }
                        isRequired = { false }
                    />
                {/if}
            </div>

            <div>
                <InputRadio
                    bind:key = { option }
                    name = 'price-selection'
                    value = 'perItem'
                    label = 'Maximum Item Price'
                />
                <InputMonetary
                    bind:value = { itemPrice }
                    bind:currencyCode = { subscription.currencyCode }
                    name = 'subscription.unitPrice'
                    placeholder = { DOMAIN === 'internal' ? 'E.g. 28' : 'E.g. 28 EUR per pair of jeans' }
                    isDisabled = { option !== 'perItem' }
                    isRequired = { false }
                />
            </div>

            <div>
                <InputRadio
                    bind:key = { option }
                    name = 'price-selection'
                    value = 'perKg'
                    label = 'Maximum Kilogram Price'
                />
                <InputMonetary
                    bind:value = { kiloPrice }
                    bind:currencyCode = { subscription.currencyCode }
                    name = 'subscription.unitPrice'
                    placeholder = { DOMAIN === 'internal' ? 'E.g. 16' : 'E.g. 16 EUR per kg of mixed brands' }
                    isDisabled = { option !== 'perKg' }
                    isRequired = { false }
                />
            </div>
        </div>
    </div>
{/if}

<style>
    div.s8-step-container {
        margin-bottom: 15px;
    }

    div.s8-options {
        display: grid;
        -moz-column-gap: 40px;
             column-gap: 40px;
        grid-template-columns: repeat(3, 1fr);
        position: relative;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    @media (max-width: 780px) {
        div.s8-options {
            display: flex;
            flex-direction: column;
        }
    }</style>